var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.messages && _vm.messages.length > 0)?_c('div',[_c('div',{staticClass:"module-errors"},[_vm._v(" "+_vm._s(_vm.$t('Existen campos con errores'))+" "),_c('ul',_vm._l((_vm.messages),function(m,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(m)+" ")])}),0)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }